import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  testid: string;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtErrorLabel = ({ children, testid }: Props) => {
  return (
    <span className='aterrorlabel' data-testid={testid}>
      {children}
    </span>
  );
};
/** 初期値の設定 */
AtErrorLabel.defaultProps = {};
export default AtErrorLabel;
